<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { countries } from "../../../components/CountryCode";
import Multiselect from "vue-multiselect";
import { required, email, minLength, maxLength, numeric } from "vuelidate/lib/validators";
import DropzonePopup from "../../../components/widgets/dropzone-popup";
import { alpha } from "@/helpers/helper";
//import { VueEditor } from "vue2-editor";

Vue.component("vue-phone-number-input", VuePhoneNumberInput);

//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  props: ["value"],
  components: {
    Layout,
    Multiselect,
    DropzonePopup,
    // VueEditor,
  },
  data() {
    return {
      user: {
        name: "",
        email: "",
        country_code: "",
        phone: "",
        // about: "",
        password: "",
        image: "",
        status: true,
      },
      color: {
        "text-danger": true,
      },
      title: "Users",
      countries: countries,
      items: [
        {
          text: "user",
          href: "/users",
        },
        {
          text: "Add",
          active: true,
        },
      ],
      defaultToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme button
      ],
    };
  },
  validations: {
    user: {
      name: {
        required,
        alpha,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      // password_cofirmed: {
      //       required,
      //       minLength: minLength(6),
      //       maxLength: maxLength(20),
      //       sameAsPassword: sameAs("password"),
      //   },
      phone: {
        numeric,
        minLength: minLength(6),
        maxLength: maxLength(15),
      },
      // about: {
      //   minLength: minLength(3),
      //   maxLength: maxLength(8000),
      // },
    },
  },
  mounted() {
    this.user.country_code = this.countries[76];
  },
  computed: mapGetters("user", [
    "loading",
    "userCount",
    "userData",
    "users",
    "paginations",
  ]),
  methods: {
    ...mapActions("user", ["createUser"]),
    create() {
      this.$v.user.$touch();
      if (this.$v.user.$invalid) {
        return;
      } else {
        var data = this.user;
        this.createUser(data).then((res) => {
          if (res) this.$router.push({ name: "user.list" });
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="text-left mb-4">
          <a href="#" class="router-link-active" @click="$router.back()">
            <i class="bx bx-arrow-back"></i>
            Back
          </a>
        </div>
        <div class="card">
          <div class="card-header">
            <div
              class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
            >
              <div class="page-title-left avatar-main-icon" style="display: flex">
                <div class="avatar-xs mr-3">
                  <span
                    class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                  >
                    <i class="bx bx-user-circle"></i>
                  </span>
                </div>
                <div class="report-tag">
                  <h4 class="mb-0 font-size-18">ADD USERS</h4>
                  <p>
                    <router-link :to="{ name: 'user.list' }">User </router-link>
                    > Add User
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="create">
              <div class="row">
                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Name <span :class="color">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      v-model="user.name"
                      :class="{ 'is-invalid': $v.user.name.$error }"
                      placeholder="Name"
                    />
                    <div v-if="$v.user.name.$error" class="invalid-feedback">
                      <span v-if="!$v.user.name.required"> Please enter name</span>
                      <span v-if="!$v.user.name.alpha">
                        {{ $t("Enter only alphabet") }}</span
                      >
                      <span v-if="!$v.user.name.minLength">
                        {{ $t("Name should not less than 3") }}</span
                      >
                      <span v-if="!$v.user.name.maxLength">
                        {{ $t("Name should not more than 100") }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Email <span :class="color">*</span></label>
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      v-model="user.email"
                      :class="{ 'is-invalid': $v.user.email.$error }"
                      placeholder="Email"
                    />
                    <div v-if="$v.user.email.$error" class="invalid-feedback">
                      <span v-if="!$v.user.email.required"> Please enter email</span>
                      <span v-if="!$v.user.email.email">
                        {{ $t("Please enter valid formate") }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-6 mb-2">
                  <div class="form-group phone">
                    <label>Phone Number</label>
                    <div class="input-group">
                      <div class="input-group-prepend" style="width: 80px">
                        <multiselect
                          v-model="user.country_code"
                          :options="countries"
                          :searchable="true"
                          track-by="label"
                          label="value"
                          placeholder="Code"
                          :taggable="true"
                          name="country_code"
                        >
                          <template v-slot:tag="{ option, handleTagRemove, disabled }">
                            <div class="multiselect-tag is-user">
                              <span> {{ option.value }}</span>
                              <i
                                v-if="!disabled"
                                @click.prevent
                                @mousedown.prevent.stop="handleTagRemove(option, $event)"
                              />
                            </div>
                          </template>
                          <template v-slot:option="{ option }">
                            {{ option.label }} ({{ option.value }})
                          </template>
                        </multiselect>
                      </div>

                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        name="phone"
                        v-model="user.phone"
                        placeholder="Phone Number"
                        :class="{ 'is-invalid': $v.user.phone.$error }"
                      />

                      <div v-if="$v.user.phone.$error" class="invalid-feedback">
                        <span v-if="!$v.user.phone.numeric">
                          {{ $t("Mobile Number must be numeric") }}</span
                        >
                        <span v-if="!$v.user.phone.maxLength">
                          {{ $t("Mobile number must be 15 digit") }}</span
                        >
                        <span v-if="!$v.user.phone.minLength">
                          {{ $t("Mobile number must be less than 8 digit") }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      class="form-control"
                      name="password"
                      v-model="user.password"
                      :class="{ 'is-invalid': $v.user.password.$error }"
                      placeholder="Password"
                    />
                    <div v-if="$v.user.password.$error" class="invalid-feedback">
                      <span v-if="!$v.user.password.required">
                        Please enter password</span
                      >
                      <span v-if="!$v.user.password.minLength">
                        {{ $t("Password must be 6 digit") }}</span
                      >
                    </div>
                  </div>
                </div>
                <!-- <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>About</label> -->
                <!-- <vue-editor
                      v-model="user.about"
                      :class="{ 'is-invalid': $v.user.about.$error }"
                      :editorToolbar="defaultToolbar"
                    ></vue-editor> -->
                <!-- <textarea
                      rows="5"
                      cols="159"
                      name="about"
                      v-model="user.about"
                      :class="{ 'is-invalid': $v.user.about.$error }"
                      placeholder="About"
                      class="form-control"
                    ></textarea>
                    <div v-if="$v.user.about.$error" class="invalid-feedback">
                      <span v-if="!$v.user.about.maxLength">
                        {{ $t("About should not more than 8000") }}</span
                      >
                      <span v-if="!$v.user.about.minLength">
                        {{ $t("About should not less than 3") }}</span
                      >
                    </div>
                  </div>
                </div> -->

                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Profile</label>
                    <dropzone-popup
                      v-model="user.image"
                      id="image"
                      name="image"
                      acceptedFiles=".jpeg,.jpg,.png"
                    />
                  </div>
                </div>

                <div class="col-6 mb-2">
                  <div class="form-group">
                    <label>Status</label>
                    <b-form-checkbox
                      switch
                      size="lg"
                      v-model="user.status"
                      class="ml-1"
                    ></b-form-checkbox>
                  </div>
                </div>

                <div class="col-12 pt-4">
                  <button type="submit" class="btn btn-primary">Save</button>
                  <b-button
                    @click="$router.back()"
                    type="button"
                    variant="secondary"
                    class="ml-3"
                    >Cancel
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
